import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, getErrorMessage } from '../../api/client';
import './DemoPages.css';

const DemoVerifyPage: React.FC = () => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const [isVerifying, setIsVerifying] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setError(t('demo.verify.invalidToken'));
        setIsVerifying(false);
        return;
      }

      try {
        const response = await api.public.verifyDemo(token);
        if (response.data.valid) {
          setIsValid(true);
          setEmail(response.data.email);
          // Store token for the setup step
          sessionStorage.setItem('demoToken', token);
          sessionStorage.setItem('demoEmail', response.data.email);
        } else {
          setError(t('demo.verify.invalidToken'));
        }
      } catch (err) {
        setError(getErrorMessage(err));
      } finally {
        setIsVerifying(false);
      }
    };

    verifyToken();
  }, [token, t]);

  const handleContinue = () => {
    navigate('/demo/setup');
  };

  if (isVerifying) {
    return (
      <div className="demo-page">
        <div className="demo-container">
          <div className="demo-loading">
            <i className="fas fa-spinner fa-spin"></i>
            <h2>{t('demo.verify.verifying')}</h2>
            <p>{t('demo.verify.pleaseWait')}</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !isValid) {
    return (
      <div className="demo-page">
        <div className="demo-container">
          <div className="demo-error">
            <i className="fas fa-exclamation-circle"></i>
            <h1>{t('demo.verify.errorTitle')}</h1>
            <p>{error || t('demo.verify.invalidToken')}</p>
            <div className="demo-error-actions">
              <Link to="/demo" className="btn btn--primary">
                {t('demo.verify.requestNew')}
              </Link>
              <Link to="/" className="btn btn--secondary">
                {t('demo.backToHome')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="demo-page">
      <div className="demo-container">
        <div className="demo-success">
          <i className="fas fa-check-circle"></i>
          <h1>{t('demo.verify.successTitle')}</h1>
          <p>{t('demo.verify.successMessage')}</p>
          <p className="demo-email-verified">{email}</p>

          <button
            onClick={handleContinue}
            className="btn btn--primary"
          >
            {t('demo.verify.continue')} <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoVerifyPage;
